import { Info } from "@mui/icons-material";
import { Box, Tooltip, Autocomplete, TextField } from "@mui/material";

const DocumentTypeEditor = ({
  documentType,
  docTypeOptions,
  selectedDocType,
  handleDocumentTypeChange,
  rowId,
  fileReq,
}) => {
  return (
    <Box className="flex w-full items-center">
      {documentType === "Choose Type" ? (
        ""
      ) : (
        <Box style={{ marginRight: "5px" }}>
          <Tooltip
            title={`Supported File Extensions - ${fileReq}.  If the current file type doesn't match the required types,
          please delete doc and upload a new version.`}
          >
            <Info style={{ fontSize: "18px" }} />
          </Tooltip>
        </Box>
      )}
      <Box className="w-full">
        <Autocomplete
          disablePortal
          size="small"
          className="flex w-full items-center"
          options={docTypeOptions || []}
          getOptionLabel={(option) => option.display_name}
          value={selectedDocType || null}
          onChange={(e, value) => handleDocumentTypeChange(rowId, value)}
          renderInput={(params) => (
            <TextField {...params} label="Document Type" variant="outlined" size="small" />
          )}
        />
      </Box>
    </Box>
  );
};

export default DocumentTypeEditor;
